import netsSipCompact from './nets-sip-compact';

export default angular
  .module('app.sipCompact', [])
  .component('netsSipCompact', netsSipCompact);
